"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Amplitude = void 0;
const analytics_browser_1 = require("@amplitude/analytics-browser");
const constants_1 = require("../constants");
var API_KEYS_LIST;
(function (API_KEYS_LIST) {
    API_KEYS_LIST["sb.prod"] = "b76ca14329ceff730b7654d5bb46bace";
    API_KEYS_LIST["sb.dev"] = "0f7c7db191d47aad5fcae36b013a2139";
    API_KEYS_LIST["br.prod"] = "77b93f98e0ddb44d4f850c54dcaf559";
    API_KEYS_LIST["br.dev"] = "3291466a1d1d4b088cc53cb59c283646";
    API_KEYS_LIST["cs.prod"] = "";
    API_KEYS_LIST["cs.dev"] = "";
    API_KEYS_LIST["uk.prod"] = "";
    API_KEYS_LIST["uk.dev"] = "";
})(API_KEYS_LIST || (API_KEYS_LIST = {}));
class Amplitude {
    constructor(project, environment, platform, version) {
        this.API_URL = 'https://api2.amplitude.com/2/httpapi';
        this.platform = constants_1.Platform.web;
        this.project = project;
        this.environment = environment || this.detectEnv();
        this.platform = platform || this.detectDeviceType();
        this.version = version;
        this.API_KEY = this.chooseApiKey();
    }
    chooseApiKey() {
        const fullEnv = `${this.project}.${this.environment}`;
        return API_KEYS_LIST[fullEnv];
    }
    initAmplitude(shouldTrackPageViews = true) {
        (0, analytics_browser_1.init)(this.API_KEY, {
            logLevel: this.environment === constants_1.Environment.dev ? analytics_browser_1.Types.LogLevel.Debug : analytics_browser_1.Types.LogLevel.None,
            defaultTracking: {
                pageViews: shouldTrackPageViews,
                attribution: true
            },
        });
    }
    trackAmplitudeEvent(eventName, userId, options) {
        try {
            let event = {
                event_type: eventName,
                platform: this.platform,
                event_properties: Object.assign({ url: document.location.href, version: this.version }, options),
            };
            if (userId) {
                event.user_id = String(userId);
            }
            (0, analytics_browser_1.track)(event);
        }
        catch (err) {
            console.error(`mr. BUGster is here! Can't send event to the amplitude. That's the reason ${err}`, eventName);
        }
    }
    trackAmplitudeEventViaBeacon(eventName, userId, options) {
        try {
            let event = {
                event_type: eventName,
                device_id: (0, analytics_browser_1.getDeviceId)(),
                session_id: (0, analytics_browser_1.getSessionId)(),
                platform: this.platform,
                event_properties: Object.assign({ url: document.location.href, version: this.version }, options),
            };
            if (userId) {
                event.user_id = String(userId);
            }
            const payload = {
                api_key: this.API_KEY,
                events: [event]
            };
            navigator.sendBeacon(this.API_URL, JSON.stringify(payload));
        }
        catch (err) {
            console.error(`mr. BUGster is here! Can't send event to the amplitude. That's the reason ${err}`, eventName);
        }
    }
    detectEnv() {
        return constants_1.isDev ? constants_1.Environment.dev : constants_1.Environment.prod;
    }
    detectDeviceType() {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return constants_1.Platform.tabletWeb;
        }
        else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return constants_1.Platform.mobileWeb;
        }
        return constants_1.Platform.desktopWeb;
    }
    getDeviceId() {
        return (0, analytics_browser_1.getDeviceId)();
    }
}
exports.Amplitude = Amplitude;
